/*
 * @Author: lbh
 * @Date: 2022-07-16 14:44:21
 * @LastEditors: lbh
 * @LastEditTime: 2023-08-17 11:02:20
 * @Description: 埋點
 */
import { addClickHead } from "@/js/api/system/api";
import util from "@/js/util/util.js";
import K from "@/js/util/loca_key";
import MobileDetect from "mobile-detect";
let point = {
  log(obj = {}) {
    var md = new MobileDetect(window.navigator.userAgent);
    let params = {
      logType: obj.logType || "",
      appType: obj.appType || "7",
      webSource: md.userAgent() || "PC",
      memberId: util.userInfoFun.get().id || "", // 用戶id
      deviceId: localStorage.getItem("ricepos_user_murmur"), // 用戶 token
      environment: md.ua,
      brandId: obj.brandId || localStorage.getItem(K.brand_id) || "",
      restaurantId:
        obj.restaurantId || localStorage.getItem(K.restaurant_id) || "",
      contentType: obj.contentType || "",
      contentId: obj.contentId || "",
    };
    console.log("restaurantId:", params.restaurantId);
    console.log("brandId:", params.brandId);
    addClickHead(params);
  },
};

export default point;
